import React, { useEffect } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';

import "./pop-up4.css"
import Button1, { Button1Config } from './button1';
import Button3, { Button3Config } from './button3';
import TextSize from './text-size';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../misc/tools';

class PopUp4Caching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'logo',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/logo.png'
			}
		];
	}
}

export const popUp4Caching = new PopUp4Caching();

const PopUp4 = (props: PopUp4Config) => {
	return (
		<div className="modal-disable-select center-element main-content pop-up4-container" style={{
		}}>
			{props.hideEverythingButButtons ? (null) : (
				<>
					<div className='pop-up4-row' style={{height: '140px'}}>
						<img className={`pop-up4-logo center-element-vertical ${constants.mainContent508Id}`} src={popUp4Caching.getItemByKey('logo').src} alt={'JCDST (Just Culture Decision Support Tool) Simulation Logo'}/>
						{props.title && (
							<h1 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h1)}} className='title-text pop-up4-title'>{props.title}</h1>
						)}
					</div>

					<div className='pop-up4-description pop-up4-row' style={{marginBottom: '10px'}}>
						{props.onRenderContent()}
					</div>
				</>
			)}

			<div className='pop-up4-buttons-container'>
				<div className='pop-up4-buttons-inner-container black-text' style={{
					width: props.hideEverythingButButtons ? '98%' : '98%',
					marginTop: props.hideEverythingButButtons ? '25px' : undefined,
					marginBottom: props.hideEverythingButButtons ? '25px' : undefined,
					height: props.hideEverythingButButtons ? '450px' : '540px'
				}}>
					{props.toggleButtons.map((buttonProps: Button3Config, i: number) => {
						return (
							<div key={Tools.generateGuid()} style={{
									marginBottom: '10px',
									marginTop: i === 0 && props.hideEverythingButButtons ? '10px' : '0'}}>
								<Button3 props={buttonProps}></Button3>
							</div>
						);
					})}
					<div style={{
						width: '100%'
					}}>
						<TextSize></TextSize>
					</div>
				</div>
				
				{props.previousMenuBttn ? <div style={{marginBottom: '10px', marginTop: '10px', color: 'black', width: "96%"}}>
					<Button1 props={props.previousMenuBttn}></Button1>
				</div> : (null)}
			</div>
		</div>
	);

};

export interface PopUp4Config extends BaseConfig {
	hideEverythingButButtons?: boolean;
	title: string;
	onRenderContent: () => any;
	toggleButtons: Button3Config[];
	previousMenuBttn?: Button1Config;
}

export default PopUp4;